import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveCopChangeCriticality = api(async function saveCopChangeCriticality({ id, changeId, criticality }) {
    return mutate(
        gql`
            mutation SaveCopChangeCriticality($id: ID!, $changeId: String!, $criticality: String) {
                saveCopChangeCriticality(id: $id, changeId: $changeId, criticality: $criticality)
            }
        `,
        { id, changeId, criticality },
        { returns: "saveCopChangeCriticality" }
    )
})
